export const DOMAIN = 'getjerry.com';
export const SITE_URL = `https://${DOMAIN}`;

/**
 * Get the domain
 * @returns The domain
 */
export const getDomain = () => {
  if (typeof window === 'undefined' || process.env.NODE_ENV === 'development') {
    return DOMAIN;
  }

  return window.location.hostname;
};

/**
 * Get the site URL
 * @returns The site URL
 */
export const getSiteUrl = () => {
  if (typeof window === 'undefined' || process.env.NODE_ENV === 'development') {
    return SITE_URL;
  }

  return window.location.origin;
};
